import React from 'react';
import Icon from '../../../components/AppIcon';

const RiskIndicators = ({ actions }) => {
  const calculateRisks = () => {
    const criticalDelayed = actions?.filter(a => 
      a?.priority === 'critical' && a?.progress < 50
    )?.length;

    const budgetOverrun = actions?.filter(a => 
      a?.budget && a?.budget > 100000000
    )?.length;

    const dependencyIssues = actions?.filter(a => 
      a?.dependencies && a?.dependencies?.length > 2
    )?.length;

    const resourceConstraints = actions?.filter(a => 
      a?.progress === 0 && a?.priority !== 'low'
    )?.length;

    return {
      criticalDelayed,
      budgetOverrun,
      dependencyIssues,
      resourceConstraints
    };
  };

  const risks = calculateRisks();

  const riskItems = [
    {
      icon: 'AlertTriangle',
      label: 'Aksi Kritis Terlambat',
      value: risks?.criticalDelayed,
      severity: risks?.criticalDelayed > 0 ? 'high' : 'low',
      description: 'Aksi prioritas kritis dengan progress &lt; 50%'
    },
    {
      icon: 'DollarSign',
      label: 'Potensi Budget Overrun',
      value: risks?.budgetOverrun,
      severity: risks?.budgetOverrun > 2 ? 'high' : 'medium',
      description: 'Aksi dengan budget &gt; Rp 100 juta'
    },
    {
      icon: 'Link',
      label: 'Kompleksitas Dependensi',
      value: risks?.dependencyIssues,
      severity: risks?.dependencyIssues > 3 ? 'high' : 'low',
      description: 'Aksi dengan banyak dependensi'
    },
    {
      icon: 'Users',
      label: 'Kendala Sumber Daya',
      value: risks?.resourceConstraints,
      severity: risks?.resourceConstraints > 2 ? 'medium' : 'low',
      description: 'Aksi prioritas tinggi belum dimulai'
    }
  ];

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'high': return 'border-error bg-error/5';
      case 'medium': return 'border-warning bg-warning/5';
      default: return 'border-success bg-success/5';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'high': return { name: 'XCircle', color: 'text-error' };
      case 'medium': return { name: 'AlertCircle', color: 'text-warning' };
      default: return { name: 'CheckCircle2', color: 'text-success' };
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-error/10 flex items-center justify-center">
          <Icon name="AlertTriangle" size={20} className="text-error" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Indikator Risiko Implementasi</h3>
          <p className="text-sm text-muted-foreground">Monitoring risiko eksekusi rencana aksi</p>
        </div>
      </div>
      <div className="space-y-4">
        {riskItems?.map((risk, index) => {
          const severityIcon = getSeverityIcon(risk?.severity);
          return (
            <div 
              key={index}
              className={`rounded-lg border-2 p-4 transition-all duration-250 ${getSeverityColor(risk?.severity)}`}
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-3">
                  <Icon name={risk?.icon} size={20} className="text-foreground" />
                  <div>
                    <h4 className="font-semibold text-foreground">{risk?.label}</h4>
                    <p className="text-xs text-muted-foreground mt-0.5">{risk?.description}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-2xl font-bold text-foreground">{risk?.value}</span>
                  <Icon name={severityIcon?.name} size={20} className={severityIcon?.color} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-6 p-4 bg-muted rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-primary mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground mb-1">Rekomendasi Mitigasi</p>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• Prioritaskan aksi kritis dengan progress rendah</li>
              <li>• Review alokasi budget untuk aksi high-value</li>
              <li>• Identifikasi bottleneck pada dependensi kompleks</li>
              <li>• Alokasikan resource untuk aksi prioritas tinggi</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskIndicators;